import { useParams } from 'react-router-dom';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';

import PaymentHistoryForm from '../../modules/receivable/history/components/PaymentHistoryForm';

const PaymentHistoryCxcPage = () => {
  const { receivableId } = useParams();

  const parsedReceivableId = receivableId ? Number(receivableId) : undefined;

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <PaymentHistoryForm
          key={parsedReceivableId}
          receivableId={parsedReceivableId}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PaymentHistoryCxcPage;
